import React, { useEffect, useState } from "react";
import "./othersmodule.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import CustomTheme from "../../Customtheme/Themes"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const LatencyTypesDrawer = ({
  getLatencyType,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const handleDrawerClose = (event) => {
      setIsDrawerOpen(false);
  };
  const createNewLtencyType = () => {
    const latency_type_desc = information?.latency_type_desc?.trim();
    const latency_type_name = information?.latency_type_name?.trim();
    if ( latency_type_name.length == 0) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 5000);
      return;
    }
    const body = {
      latency_type_id: information?.latency_type_id,
      latency_type_desc: information?.latency_type_desc,
      latency_type_name: information?.latency_type_name,
    };
    setBackDrop(true);
    instance
      .post("api/v1/Master/LatencyType/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getLatencyType();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        setInformation({
          latency_type_name:"",
          latency_type_desc:""

        })
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  const onChanageHandler = (event) => {
    const { id, value, type } = event?.target;
    if (type == "checkbox") {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: event?.target?.checked == true ? 1 : 0,
        };
      });
    } else {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: value,
        };
      });
    }
  };
  useEffect(() => {
    setInformation({
      latency_type_id: filledInfo?.latency_type_id ?? "",
      latency_type_desc: filledInfo?.latency_type_desc ?? "",
      latency_type_name: filledInfo?.latency_type_name ?? "",
    });
  }, [drawerCaller]);
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {
          width: drawerWidth, 
        },
      }}
    >
      <div
        style={{ padding: "20px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backOthr"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon  onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorOthr mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Latency Type{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorOthr mb-1"
              style={{ fontWeight: "600" }}
            >
              Latency Type Information{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="latency_type_name">Name<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="latency_type_name"
              size="small"
              variant="outlined"
              fullWidth
              value={information?.latency_type_name}
              onChange={onChanageHandler}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="latency_type_desc">Description</InputLabel>
            <TextField
              id="latency_type_desc"
              size="small"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={information?.latency_type_desc}
              onChange={onChanageHandler}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={createNewLtencyType}
            >
              {type == "Add" ? " Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default LatencyTypesDrawer;
